import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=58b90a0d&scoped=true"
import script from "./teaser.vue?vue&type=script&lang=js"
export * from "./teaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b90a0d",
  null
  
)

export default component.exports